import { useEffect, useState } from 'react';

/**
 * Track a CSS media query from React.
 *
 * Guarded for environments without `matchMedia` (jsdom under test, and the
 * thumbnail/preview passes): those report false and get the desktop rendering,
 * which is the safe default rather than a crash.
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const list = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(list.matches);
    // Safari below 14 only has the deprecated addListener.
    if (list.addEventListener) list.addEventListener('change', onChange);
    else list.addListener(onChange);
    return () => {
      if (list.removeEventListener) list.removeEventListener('change', onChange);
      else list.removeListener(onChange);
    };
  }, [query]);

  return matches;
}

/** The breakpoint the stylesheet already uses to switch to the phone layout. */
export const MOBILE_QUERY = '(max-width: 768px)';
